var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
import { get } from 'lodash';
import { SECTION_HOMEPAGE, SECTION_CATEGORY, SECTION_MY_POSTS, SECTION_POST_LIST } from './sections';
import { LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM, LAYOUT_PG_CARD_MEDIUM, LAYOUT_PG_SIDE_BY_SIDE, LAYOUT_PG_GRID, LAYOUT_PG_ONE_COLUMN, LAYOUT_LIST, LAYOUT_SLIDER, } from './layout-types';
export var PG_LAYOUT_IMAGE_RATIO_OPTIONS = {
    RATIO_16ON9: 1,
    RATIO_4ON3: 2,
    SQUARE: 3,
    RATIO_3ON4: 4,
    RATIO_9ON16: 5,
    RATIO_16ON7: 6,
};
export var PG_LAYOUT_IMAGE_RATIOS_BY_ID = {
    1: 'RATIO_16ON9',
    2: 'RATIO_4ON3',
    3: 'SQUARE',
    4: 'RATIO_3ON4',
    5: 'RATIO_9ON16',
    6: 'RATIO_16ON7',
};
export var PG_LAYOUT_IMAGE_ALIGNMENT_OPTIONS = {
    RIGHT_ALIGN: 1,
    LEFT_ALIGN: 2,
};
export var PG_LAYOUT_IMAGE_CROP_TYPE_OPTIONS = {
    CROP: '0',
    MAX: '1',
};
export var DEFAULT_PG_LAYOUT_IMAGE_RATIO = 'DEFAULT_PG_LAYOUT_IMAGE_RATIO';
export var DEFAULT_PG_LAYOUT_ITEM_SIZE = 'DEFAULT_PG_LAYOUT_ITEM_SIZE';
export var DEFAULT_PG_LAYOUT_INFO_SIZE = 'DEFAULT_PG_LAYOUT_INFO_SIZE';
export var DEFAULT_PG_LAYOUT_SPACNG = 'DEFAULT_PG_LAYOUT_SPACNG';
export var DEFAULT_PG_LAYOUT_SIDES_PADDING = 'DEFAULT_PG_LAYOUT_SIDES_PADDING';
export var DEFAULT_PG_LAYOUT_MARGINS = 'DEFAULT_PG_LAYOUT_MARGINS';
export var DEFAULT_PG_IMAGE_ALIGNMENT = 'DEFAULT_PG_IMAGE_ALIGNMENT';
export var DEFAULT_PG_IMAGE_PROPORTIONS = 'DEFAULT_PG_IMAGE_PROPORTIONS';
export var DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE = 'DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE';
export var DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT = 'DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT';
export var DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT = 'DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT';
export var MIN_PG_LAYOUT_SPACNG = 'MIN_PG_LAYOUT_SPACNG';
export var MIN_PG_LAYOUT_ITEM_SIZE = 'MIN_PG_LAYOUT_ITEM_SIZE';
export var MIN_PG_LAYOUT_INFO_SIZE = 'MIN_PG_LAYOUT_INFO_SIZE';
export var MIN_PG_LAYOUT_SIDES_PADDING = 'MIN_PG_LAYOUT_SIDES_PADDING';
export var MIN_PG_LAYOUT_MARGINS = 'MIN_PG_LAYOUT_MARGINS';
export var MIN_PG_LAYOUT_TITLE_LINE_COUNT = 'MIN_PG_LAYOUT_TITLE_LINE_COUNT';
export var MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT = 'MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT';
export var MIN_PG_IMAGE_ALIGNMENT = 'MIN_PG_IMAGE_ALIGNMENT';
export var MIN_PG_IMAGE_PROPORTIONS = 'MIN_PG_IMAGE_PROPORTIONS';
export var MAX_PG_LAYOUT_ITEM_SIZE = 'MAX_PG_LAYOUT_ITEM_SIZE';
export var MAX_PG_LAYOUT_INFO_SIZE = 'MAX_PG_LAYOUT_INFO_SIZE';
export var MAX_PG_LAYOUT_SPACNG = 'MAX_PG_LAYOUT_SPACNG';
export var MAX_PG_LAYOUT_SIDES_PADDING = 'MAX_PG_LAYOUT_SIDES_PADDING';
export var MAX_PG_LAYOUT_MARGINS = 'MAX_PG_LAYOUT_MARGINS';
export var MAX_PG_LAYOUT_TITLE_LINE_COUNT = 'MAX_PG_LAYOUT_TITLE_LINE_COUNT';
export var MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT = 'MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT';
export var MAX_PG_IMAGE_ALIGNMENT = 'MAX_PG_IMAGE_ALIGNMENT';
export var MAX_PG_IMAGE_PROPORTIONS = 'MAX_PG_IMAGE_PROPORTIONS';
export var DEFAULT_PG_LAYOUT_SPACING_MOBILE = 'DEFAULT_PG_LAYOUT_SPACING_MOBILE';
export var DEFAULT_PG_LAYOUT_MARGINS_MOBILE = 'DEFAULT_PG_LAYOUT_MARGINS_MOBILE';
export var DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE = 'DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE';
var PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS = (_a = {},
    _a[MIN_PG_LAYOUT_SPACNG] = 0,
    _a[MIN_PG_LAYOUT_ITEM_SIZE] = 150,
    _a[MIN_PG_LAYOUT_SIDES_PADDING] = 0,
    _a[MIN_PG_LAYOUT_MARGINS] = 0,
    _a[MIN_PG_LAYOUT_TITLE_LINE_COUNT] = 1,
    _a[MAX_PG_LAYOUT_SPACNG] = 100,
    _a[MAX_PG_LAYOUT_ITEM_SIZE] = 1000,
    _a[MAX_PG_LAYOUT_SIDES_PADDING] = 100,
    _a[MAX_PG_LAYOUT_MARGINS] = 100,
    _a[MAX_PG_LAYOUT_TITLE_LINE_COUNT] = 6,
    _a[DEFAULT_PG_LAYOUT_IMAGE_RATIO] = 3,
    _a[DEFAULT_PG_LAYOUT_ITEM_SIZE] = 454,
    _a[DEFAULT_PG_LAYOUT_SPACNG] = 32,
    _a[DEFAULT_PG_LAYOUT_SIDES_PADDING] = 30,
    _a[DEFAULT_PG_LAYOUT_MARGINS] = 20,
    _a[DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE] = 0,
    _a[DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT] = 3,
    _a[DEFAULT_PG_LAYOUT_SPACING_MOBILE] = 20,
    _a[DEFAULT_PG_LAYOUT_MARGINS_MOBILE] = 0,
    _a[DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE] = 3,
    _a);
var PG_CARD_MEDIUM_SETTINGS = (_b = {},
    _b[MIN_PG_LAYOUT_SPACNG] = 0,
    _b[MIN_PG_LAYOUT_ITEM_SIZE] = 150,
    _b[MIN_PG_LAYOUT_INFO_SIZE] = 0,
    _b[MIN_PG_LAYOUT_SIDES_PADDING] = 0,
    _b[MIN_PG_LAYOUT_MARGINS] = 0,
    _b[MIN_PG_LAYOUT_TITLE_LINE_COUNT] = 1,
    _b[MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 1,
    _b[MAX_PG_LAYOUT_SPACNG] = 100,
    _b[MAX_PG_LAYOUT_ITEM_SIZE] = 1000,
    _b[MAX_PG_LAYOUT_INFO_SIZE] = 700,
    _b[MAX_PG_LAYOUT_SIDES_PADDING] = 100,
    _b[MAX_PG_LAYOUT_MARGINS] = 100,
    _b[MAX_PG_LAYOUT_TITLE_LINE_COUNT] = 6,
    _b[MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 8,
    _b[DEFAULT_PG_LAYOUT_ITEM_SIZE] = 454,
    _b[DEFAULT_PG_LAYOUT_INFO_SIZE] = 350,
    _b[DEFAULT_PG_LAYOUT_SPACNG] = 32,
    _b[DEFAULT_PG_LAYOUT_SIDES_PADDING] = 30,
    _b[DEFAULT_PG_LAYOUT_MARGINS] = 20,
    _b[DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT] = 3,
    _b[DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 3,
    _b);
var PG_SIDE_BY_SIDE_SETTINGS = (_c = {},
    _c[MIN_PG_LAYOUT_ITEM_SIZE] = 450,
    _c[MIN_PG_LAYOUT_SPACNG] = 0,
    _c[MIN_PG_LAYOUT_SIDES_PADDING] = 0,
    _c[MIN_PG_LAYOUT_MARGINS] = 0,
    _c[MIN_PG_IMAGE_PROPORTIONS] = 20,
    _c[MIN_PG_LAYOUT_TITLE_LINE_COUNT] = 1,
    _c[MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 1,
    _c[MAX_PG_LAYOUT_ITEM_SIZE] = 1200,
    _c[MAX_PG_LAYOUT_SPACNG] = 100,
    _c[MAX_PG_LAYOUT_SIDES_PADDING] = 100,
    _c[MAX_PG_LAYOUT_MARGINS] = 100,
    _c[MAX_PG_IMAGE_PROPORTIONS] = 60,
    _c[MAX_PG_LAYOUT_TITLE_LINE_COUNT] = 6,
    _c[MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 8,
    _c[DEFAULT_PG_LAYOUT_ITEM_SIZE] = 1100,
    _c[DEFAULT_PG_LAYOUT_SPACNG] = 32,
    _c[DEFAULT_PG_LAYOUT_SIDES_PADDING] = 36,
    _c[DEFAULT_PG_LAYOUT_MARGINS] = 20,
    _c[DEFAULT_PG_IMAGE_PROPORTIONS] = 50,
    _c[DEFAULT_PG_IMAGE_ALIGNMENT] = 2,
    _c[DEFAULT_PG_LAYOUT_IMAGE_RATIO] = 2,
    _c[DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE] = 0,
    _c[DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT] = 3,
    _c[DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 3,
    _c);
var PG_SIDE_BY_SIDE_MY_POSTS_SETTINGS = (_d = {},
    _d[DEFAULT_PG_LAYOUT_ITEM_SIZE] = 1100,
    _d[DEFAULT_PG_LAYOUT_SPACNG] = 24,
    _d[DEFAULT_PG_LAYOUT_SIDES_PADDING] = 30,
    _d[DEFAULT_PG_LAYOUT_MARGINS] = 30,
    _d[DEFAULT_PG_IMAGE_PROPORTIONS] = 20,
    _d[DEFAULT_PG_IMAGE_ALIGNMENT] = 2,
    _d[DEFAULT_PG_LAYOUT_IMAGE_RATIO] = 3,
    _d[DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE] = 0,
    _d[DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT] = 2,
    _d[DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 0,
    _d);
var PG_GRID_SETTINGS = (_e = {},
    _e[MIN_PG_LAYOUT_SPACNG] = 0,
    _e[MIN_PG_LAYOUT_ITEM_SIZE] = 150,
    _e[MIN_PG_LAYOUT_INFO_SIZE] = 0,
    _e[MIN_PG_LAYOUT_SIDES_PADDING] = 0,
    _e[MIN_PG_LAYOUT_MARGINS] = 0,
    _e[MIN_PG_LAYOUT_TITLE_LINE_COUNT] = 1,
    _e[MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 1,
    _e[MAX_PG_LAYOUT_SPACNG] = 100,
    _e[MAX_PG_LAYOUT_ITEM_SIZE] = 1000,
    _e[MAX_PG_LAYOUT_INFO_SIZE] = 700,
    _e[MAX_PG_LAYOUT_SIDES_PADDING] = 100,
    _e[MAX_PG_LAYOUT_MARGINS] = 100,
    _e[MAX_PG_LAYOUT_TITLE_LINE_COUNT] = 6,
    _e[MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 8,
    _e[DEFAULT_PG_LAYOUT_IMAGE_RATIO] = 2,
    _e[DEFAULT_PG_LAYOUT_ITEM_SIZE] = 292,
    _e[DEFAULT_PG_LAYOUT_INFO_SIZE] = 350,
    _e[DEFAULT_PG_LAYOUT_SPACNG] = 32,
    _e[DEFAULT_PG_LAYOUT_SIDES_PADDING] = 24,
    _e[DEFAULT_PG_LAYOUT_MARGINS] = 20,
    _e[DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE] = 0,
    _e[DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT] = 3,
    _e[DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 3,
    _e[DEFAULT_PG_LAYOUT_SPACING_MOBILE] = 20,
    _e[DEFAULT_PG_LAYOUT_MARGINS_MOBILE] = 0,
    _e[DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE] = 2,
    _e);
var PG_ONE_COLUMN_SETTINGS = (_f = {},
    _f[MIN_PG_LAYOUT_SPACNG] = 0,
    _f[MIN_PG_LAYOUT_SIDES_PADDING] = 0,
    _f[MIN_PG_LAYOUT_MARGINS] = 0,
    _f[MIN_PG_LAYOUT_INFO_SIZE] = 0,
    _f[MIN_PG_LAYOUT_TITLE_LINE_COUNT] = 1,
    _f[MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 1,
    _f[MAX_PG_LAYOUT_SPACNG] = 100,
    _f[MAX_PG_LAYOUT_SIDES_PADDING] = 100,
    _f[MAX_PG_LAYOUT_MARGINS] = 100,
    _f[MAX_PG_LAYOUT_INFO_SIZE] = 700,
    _f[MAX_PG_LAYOUT_TITLE_LINE_COUNT] = 6,
    _f[MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 8,
    _f[DEFAULT_PG_LAYOUT_SPACNG] = 32,
    _f[DEFAULT_PG_LAYOUT_SIDES_PADDING] = 48,
    _f[DEFAULT_PG_LAYOUT_MARGINS] = 20,
    _f[DEFAULT_PG_LAYOUT_IMAGE_RATIO] = 6,
    _f[DEFAULT_PG_LAYOUT_INFO_SIZE] = 350,
    _f[DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT] = 3,
    _f[DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 3,
    _f);
var PG_LIST_SETTINGS = (_g = {},
    _g[MIN_PG_LAYOUT_SPACNG] = 0,
    _g[MIN_PG_LAYOUT_ITEM_SIZE] = 150,
    _g[MIN_PG_LAYOUT_SIDES_PADDING] = 0,
    _g[MIN_PG_LAYOUT_MARGINS] = 0,
    _g[MIN_PG_LAYOUT_INFO_SIZE] = 0,
    _g[MIN_PG_IMAGE_PROPORTIONS] = 20,
    _g[MIN_PG_LAYOUT_TITLE_LINE_COUNT] = 1,
    _g[MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 1,
    _g[MAX_PG_LAYOUT_SPACNG] = 100,
    _g[MAX_PG_LAYOUT_ITEM_SIZE] = 1000,
    _g[MAX_PG_LAYOUT_SIDES_PADDING] = 100,
    _g[MAX_PG_LAYOUT_MARGINS] = 100,
    _g[MAX_PG_LAYOUT_INFO_SIZE] = 300,
    _g[MAX_PG_IMAGE_PROPORTIONS] = 80,
    _g[MAX_PG_LAYOUT_TITLE_LINE_COUNT] = 6,
    _g[MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 8,
    _g[DEFAULT_PG_LAYOUT_SPACNG] = 12,
    _g[DEFAULT_PG_LAYOUT_ITEM_SIZE] = 292,
    _g[DEFAULT_PG_LAYOUT_INFO_SIZE] = 100,
    _g[DEFAULT_PG_LAYOUT_SIDES_PADDING] = 12,
    _g[DEFAULT_PG_LAYOUT_MARGINS] = 0,
    _g[DEFAULT_PG_LAYOUT_IMAGE_RATIO] = 3,
    _g[DEFAULT_PG_IMAGE_PROPORTIONS] = 25,
    _g[DEFAULT_PG_IMAGE_ALIGNMENT] = 1,
    _g[DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE] = 0,
    _g[DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT] = 3,
    _g[DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 3,
    _g[DEFAULT_PG_LAYOUT_SPACING_MOBILE] = 20,
    _g[DEFAULT_PG_LAYOUT_MARGINS_MOBILE] = 0,
    _g[DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE] = 3,
    _g);
var PG_SLIDER_SETTINGS = (_h = {},
    _h[MIN_PG_LAYOUT_INFO_SIZE] = 0,
    _h[MIN_PG_LAYOUT_SIDES_PADDING] = 0,
    _h[MIN_PG_LAYOUT_MARGINS] = 0,
    _h[MIN_PG_LAYOUT_TITLE_LINE_COUNT] = 1,
    _h[MIN_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 1,
    _h[MAX_PG_LAYOUT_INFO_SIZE] = 700,
    _h[MAX_PG_LAYOUT_SIDES_PADDING] = 48,
    _h[MAX_PG_LAYOUT_MARGINS] = 100,
    _h[MAX_PG_LAYOUT_TITLE_LINE_COUNT] = 6,
    _h[MAX_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 8,
    _h[DEFAULT_PG_LAYOUT_INFO_SIZE] = 230,
    _h[DEFAULT_PG_LAYOUT_SIDES_PADDING] = 24,
    _h[DEFAULT_PG_LAYOUT_MARGINS] = 0,
    _h[DEFAULT_PG_LAYOUT_IMAGE_RATIO] = 1,
    _h[DEFAULT_PG_LAYOUT_IMAGE_CROP_TYPE] = 0,
    _h[DEFAULT_PG_LAYOUT_TITLE_LINE_COUNT] = 3,
    _h[DEFAULT_PG_LAYOUT_DESCRIPTION_LINE_COUNT] = 3,
    _h[DEFAULT_PG_LAYOUT_MARGINS_MOBILE] = 0,
    _h[DEFAULT_PG_LAYOUT_IMAGE_RATIO_MOBILE] = 2,
    _h);
var LAYOUT_SETTINGS = (_j = {},
    _j[LAYOUT_PG_TEXT_ON_IMAGE_MEDIUM] = (_k = {},
        _k[SECTION_HOMEPAGE] = PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS,
        _k[SECTION_CATEGORY] = PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS,
        _k[SECTION_POST_LIST] = PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS,
        _k[SECTION_MY_POSTS] = PG_TEXT_ON_IMAGE_MEDIUM_SETTINGS,
        _k),
    _j[LAYOUT_PG_CARD_MEDIUM] = (_l = {},
        _l[SECTION_HOMEPAGE] = PG_CARD_MEDIUM_SETTINGS,
        _l[SECTION_CATEGORY] = PG_CARD_MEDIUM_SETTINGS,
        _l[SECTION_POST_LIST] = PG_CARD_MEDIUM_SETTINGS,
        _l[SECTION_MY_POSTS] = PG_CARD_MEDIUM_SETTINGS,
        _l),
    _j[LAYOUT_PG_SIDE_BY_SIDE] = (_m = {},
        _m[SECTION_HOMEPAGE] = PG_SIDE_BY_SIDE_SETTINGS,
        _m[SECTION_CATEGORY] = PG_SIDE_BY_SIDE_SETTINGS,
        _m[SECTION_POST_LIST] = PG_SIDE_BY_SIDE_SETTINGS,
        _m[SECTION_MY_POSTS] = PG_SIDE_BY_SIDE_MY_POSTS_SETTINGS,
        _m),
    _j[LAYOUT_PG_GRID] = (_o = {},
        _o[SECTION_HOMEPAGE] = PG_GRID_SETTINGS,
        _o[SECTION_CATEGORY] = PG_GRID_SETTINGS,
        _o[SECTION_POST_LIST] = PG_GRID_SETTINGS,
        _o[SECTION_MY_POSTS] = PG_GRID_SETTINGS,
        _o),
    _j[LAYOUT_PG_ONE_COLUMN] = (_p = {},
        _p[SECTION_HOMEPAGE] = PG_ONE_COLUMN_SETTINGS,
        _p[SECTION_CATEGORY] = PG_ONE_COLUMN_SETTINGS,
        _p[SECTION_POST_LIST] = PG_ONE_COLUMN_SETTINGS,
        _p[SECTION_MY_POSTS] = PG_ONE_COLUMN_SETTINGS,
        _p),
    _j[LAYOUT_SLIDER] = (_q = {},
        _q[SECTION_HOMEPAGE] = PG_SLIDER_SETTINGS,
        _q[SECTION_CATEGORY] = PG_SLIDER_SETTINGS,
        _q[SECTION_POST_LIST] = PG_SLIDER_SETTINGS,
        _q[SECTION_MY_POSTS] = PG_SLIDER_SETTINGS,
        _q),
    _j[LAYOUT_LIST] = (_r = {},
        _r[SECTION_HOMEPAGE] = PG_LIST_SETTINGS,
        _r[SECTION_CATEGORY] = PG_LIST_SETTINGS,
        _r[SECTION_POST_LIST] = PG_LIST_SETTINGS,
        _r[SECTION_MY_POSTS] = PG_LIST_SETTINGS,
        _r),
    _j);
export var getPGLayoutSettingsConstant = function (layoutType, settingsKey, section) {
    if (section === void 0) { section = SECTION_HOMEPAGE; }
    return get(LAYOUT_SETTINGS, layoutType + "." + section + "." + settingsKey);
};
